import { z } from 'zod'
import { FreeTextCitedFactSchema, StructuredCitedFactSchema } from './citedFact'

export const RISK_FIELD_REFS = [
  'risk.raised_on',
  'risk.status',
  'risk.stage',
  'risk.owners',
  'risk.inherent_rating',
  'risk.residual_rating',
  'risk.treatment',
  'risk.deadline',
  'risk.description',
] as const
const RiskFieldRefSchema = z.enum(RISK_FIELD_REFS)
export type RiskFieldRef = z.infer<typeof RiskFieldRefSchema>

export const RiskCitationAgentInputSchema = z.object({
  type: z.literal('risk'),
  riskId: z.string().describe('The riskId shown on the risk line being cited'),
  fieldRef: RiskFieldRefSchema.describe('Which fact on the risk line is being cited.'),
  anchor: z
    .string()
    .trim()
    .min(1)
    .nullable()
    .describe(
      'Verbatim phrase from the cited field, or null. Set this only for `risk.description` or `risk.treatment`, when citing the whole text would be too broad; otherwise null.'
    ),
})

const StructuredCitedRiskFactSchema = z.strictObject({
  ...StructuredCitedFactSchema.shape,
  fieldRef: RiskFieldRefSchema,
})
const FreeTextCitedRiskFactSchema = z.strictObject({
  ...FreeTextCitedFactSchema.shape,
  fieldRef: RiskFieldRefSchema,
})
export const CitedRiskFactSchema = z.discriminatedUnion('kind', [StructuredCitedRiskFactSchema, FreeTextCitedRiskFactSchema])
export type CitedRiskFact = z.infer<typeof CitedRiskFactSchema>

const RiskCitationOriginSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('this_request') }),
  z.object({ kind: z.literal('other_request'), requestPublicId: z.string() }),
  z.object({ kind: z.literal('supplier') }),
])
export type RiskCitationOrigin = z.infer<typeof RiskCitationOriginSchema>

export const RiskCitationResolvedSchema = z.object({
  sourceType: z.literal('risk'),
  sourceLabel: z.string(),
  riskId: z.string(),
  origin: RiskCitationOriginSchema,
  citedFacts: z.array(CitedRiskFactSchema).min(1),
})
export type RiskCitationResolved = z.infer<typeof RiskCitationResolvedSchema>
